<template>
  <b-row>
    <b-col cols="12">
      <event-category-content />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import EventCategoryContent from './EventCategoryContent.vue'

export default {
  components: {
    BRow,
    BCol,

    EventCategoryContent
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>